import type { ComponentProps } from 'react';
import React from 'react';
import { Flex } from '@skin-seoul/design-system';

type ProductCardContentProps = {
  children: React.ReactNode;
} & {
  bottomSlot?: React.ReactNode;
} & ComponentProps<typeof Flex>;

export const HorizontalProductCardContent = ({ children, bottomSlot, ...props }: ProductCardContentProps) => {
  return (
    <Flex
      flexDirection="column"
      width="100%"
      paddingRight={2}
      paddingLeft={4}
      paddingTop={3}
      paddingBottom={2}
      minWidth={0}
      gap={1}
      borderRadius="0 8px 8px 0px"
      {...props}
    >
      <Flex direction="column" alignItems="start" gap={2} justifyContent="center" width="100%">
        <>{children}</>
      </Flex>
      <>{bottomSlot}</>
    </Flex>
  );
};
